import { appInfo } from '@/mocks/home';

export default function App() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">吃瓜APP</h2>
            <p className="text-sm text-foreground-600 mb-2">{appInfo.subtitle}</p>
            <p className="text-sm text-foreground-700 leading-relaxed mb-6 max-w-[500px] mx-auto lg:mx-0">
              {appInfo.desc}
            </p>
            <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-6">
              {appInfo.features.map((feat) => (
                <span key={feat} className="px-3 py-1.5 text-xs bg-background-50 text-foreground-700 rounded-full border border-background-200/70 whitespace-nowrap">
                  <i className="ri-check-line text-accent-600 mr-1"></i>
                  {feat}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-lg hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line text-lg"></i>
                App Store
              </button>
              <button className="flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </button>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative">
              <div className="absolute -inset-6 bg-primary-500/10 rounded-[2.5rem] blur-3xl"></div>
              <img
                src={appInfo.image}
                alt="51吃瓜APP界面展示"
                className="relative w-[240px] md:w-[280px] h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}